/* tslint:disable */
/* eslint-disable */
/* @relayHash 41694ff134e6e00c1375bf630822fe55 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_Login_QueryVariables = {};
export type App_Login_QueryResponse = {
    readonly manager: {
        readonly " $fragmentRefs": FragmentRefs<"LoginPage_manager">;
    } | null;
};
export type App_Login_Query = {
    readonly response: App_Login_QueryResponse;
    readonly variables: App_Login_QueryVariables;
};



/*
query App_Login_Query {
  manager {
    ...LoginPage_manager
  }
}

fragment LoginPage_manager on Manager {
  firstName
  lastName
}
*/

const node: ConcreteRequest = ({
    "kind": "Request",
    "fragment": {
        "kind": "Fragment",
        "name": "App_Login_Query",
        "type": "Query",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "manager",
                "storageKey": null,
                "args": null,
                "concreteType": "Manager",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "LoginPage_manager",
                        "args": null
                    }
                ]
            }
        ]
    },
    "operation": {
        "kind": "Operation",
        "name": "App_Login_Query",
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "manager",
                "storageKey": null,
                "args": null,
                "concreteType": "Manager",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    },
    "params": {
        "operationKind": "query",
        "name": "App_Login_Query",
        "id": null,
        "text": "query App_Login_Query {\n  manager {\n    ...LoginPage_manager\n  }\n}\n\nfragment LoginPage_manager on Manager {\n  firstName\n  lastName\n}\n",
        "metadata": {}
    }
} as any);
(node as any).hash = '97819f025d672f77832f34136670dec4';
export default node;
